import {ServiceStatus} from "../model";
import {PaginationRequestParams} from "../../common/util/pagination/PaginationUtil";


export type ServiceStatusFilter = ServiceStatus | "ANY";

export interface ServiceFilter extends PaginationRequestParams {
  anyText?: string;
  type?: string;
  status?: ServiceStatusFilter;
  startDate?: string;
  endDate?: string;
}

export const filtersEqual = (filterA: ServiceFilter, filterB: ServiceFilter) => {
  return filterA.anyText === filterB.anyText
         && filterA.type === filterB.type
         && filterA.status === filterB.status
         && filterA.startDate === filterB.startDate
         && filterA.endDate === filterB.endDate;
};
